import ForgotPasswordStepTwo from "./ForgotPasswordStepTwo";
  
  export default ForgotPasswordStepTwo;
  